import moment from "moment";
import { MILITARY_FORMAT } from "../../../helpers/datetime";
import { uniq } from "lodash";
import { shiftDuration } from "../../../helpers/post";
import React from "react";

const ShiftDetailsConfirmation = ({ shift, shifts }) => {
  if (shifts && shifts.length > 0) {
    const sortedShifts = shifts.sort((shiftA, shiftB) => moment(shiftA.startTime) - moment(shiftB.startTime));

    return <p>
      Please review and confirm the shift details below:
      <br />
      {sortedShifts.map((s) => (<div className="mt-4" key={s.id}>
        <div className="gotham-medium-font mt-2">
          {moment(s.startDate, MILITARY_FORMAT).format('dddd')},{' '}
          {uniq([s.startDate, s.endDate])
            .map((date) => moment(date, MILITARY_FORMAT).format('l'))
            .join(' - ')}
          <br />
          {moment(s.start, 'HH:mm').format('h:mm A')}
          {' - '}
          {moment(s.end, 'HH:mm').format('h:mm A')} ({shiftDuration(s)} hrs)
        </div>
      </div>))}
    </p>
  }
  return (<p>
    Please review and confirm the shift details below:
    <div className="gotham-medium-font mt-2">
      {moment(shift.startDate, MILITARY_FORMAT).format("dddd")}, {uniq([shift.startDate, shift.endDate]).map((date) => moment(date, MILITARY_FORMAT).format('l')).join(' - ')}
      <br />
      {moment(shift.start, 'HH:mm').format('h:mm A')}
      {' - '}
      {moment(shift.end, 'HH:mm').format('h:mm A')} ({shiftDuration(shift)} hrs)
    </div>
  </p>)
}

export default ShiftDetailsConfirmation;